<template>
    <flex-container>
        <text-decorator
            :size="FontSize.md"
            :color="Color.gray400"
            bold
        >
            {{ contact.name.fullName }}
        </text-decorator>
    </flex-container>
</template>

<script setup lang="ts">
    import useContactPageData from '@composables/useContactPageData';
    import { FlexContainer, TextDecorator, FontSize, Color } from '@keyvue/one-ui';

    interface Props {
        contactId: string;
    }

    const props = defineProps<Props>();

    const contactPageData = useContactPageData(props.contactId);

    const contact = await contactPageData.contact();
</script>
